import * as React from 'react'
import { Container, Navbar, Nav, Button, Stack, Badge } from 'react-bootstrap'
import Alert from 'react-bootstrap/Alert'
import { useState } from 'react'
import Accordion from 'react-bootstrap/Accordion'
import Offcanvas from 'react-bootstrap/Offcanvas'
import ProgressBar from 'react-bootstrap/ProgressBar'

function OffCanvasExample({ name, ...props }) {
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  return (
    <>
      <Button variant='primary' onClick={handleShow} className='me-2'>
        {name}
      </Button>
      <Offcanvas show={show} onHide={handleClose} {...props}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Offcanvas</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          Some text as placeholder. In real life you can have the elements you
          have chosen. Like, text, images, lists, etc.
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

const BootstrapTest = () => {
  const [show, setShow] = useState(true)
  const now = 60
  // const style = {
  //   color: 'red'
  // }

  // https://www.geeksforgeeks.org/react-bootstrap-progressbar-component/
  // https://www.bitdegree.org/learn/bootstrap-progress-bar
  // https://stackoverflow.com/questions/56977812/react-bootstrap-progress-bar-can-you-change-the-label-color
  // https://github.com/react-bootstrap/react-bootstrap/blob/master/src/ProgressBar.tsx
  // https://getbootstrap.com/docs/4.0/components/progress/
  const [countOfProgess, setCountOfProgess] = React.useState(0)

  //   React.useEffect(() => {
  //     if (ref.current) {
  //       const inner = ref.current.querySelector(".progress-bar");
  //       if ( inner ) {
  //          inner.style.backgroundColor = "green";
  //       }
  //     }
  //   }, [ref]);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCountOfProgess(oldProgress => {
        if (100 === oldProgress) return 0
        return Math.min(oldProgress + Math.random() * 10, 100)
      })
    }, 499)

    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <div>
      <Navbar bg='light' expand='lg'>
        <Container>
          <Navbar.Brand href='#home'>GastbyStrap</Navbar.Brand>
          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav className='ml-auto'>
              <Nav.Link href='#about'>About</Nav.Link>
              <Nav.Link href='#services'>Services</Nav.Link>
              <Nav.Link href='#contact'>Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div className='banner'>
        <Container>
          <h1>Welcome to My Website using Gatsby and React Boostrap</h1>
          <Button variant='primary' href='#services'>
            Explore
          </Button>
        </Container>
      </div>
      <Stack direction='horizontal' gap={2}>
        <Button as='a' variant='primary'>
          Button as link
        </Button>
        <Button as='a' variant='success'>
          Button as link
        </Button>
      </Stack>
      <div>
        <h1>
          Example heading
          <Badge bg='secondary' as={Button}>
            New
          </Badge>
        </h1>
      </div>

      <Alert dismissible variant='danger'>
        <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
        <p>Change this and that and try again.</p>
      </Alert>

      <>
        <Alert show={show} variant='success'>
          <Alert.Heading>My Alert</Alert.Heading>
          <p>
            Duis mollis, est non commodo luctus, nisi erat porttitor ligula,
            eget lacinia odio sem nec elit. Cras mattis consectetur purus sit
            amet fermentum.
          </p>
          <hr />
          <div className='d-flex justify-content-end'>
            <Button onClick={() => setShow(false)} variant='outline-success'>
              Close me
            </Button>
          </div>
        </Alert>

        {!show && <Button onClick={() => setShow(true)}>Show Alert</Button>}
      </>

      <Accordion defaultActiveKey='0'>
        <Accordion.Item eventKey='0'>
          <Accordion.Header>Accordion Item #1</Accordion.Header>
          <Accordion.Body>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey='1'>
          <Accordion.Header>Accordion Item #2</Accordion.Header>
          <Accordion.Body>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <div>
        <Button variant='primary'>Primary</Button>{' '}
        <Button variant='secondary'>Secondary</Button>{' '}
        <Button variant='success'>Success</Button>{' '}
        <Button variant='warning'>Warning</Button>{' '}
        <Button variant='danger'>Danger</Button>{' '}
        <Button variant='info'>Info</Button>{' '}
        <Button variant='light'>Light</Button>{' '}
        <Button variant='dark'>Dark</Button>
        <Button variant='link'>Link</Button>
      </div>

      <>
        {['start', 'end', 'top', 'bottom'].map((placement, idx) => (
          <OffCanvasExample
            key={idx}
            placement={placement}
            name={placement}
            data-bs-theme='dark'
          />
        ))}
      </>

      <>
        <ProgressBar now={now} label={`${now}%`} style={{ height: 30, 'backgroundColor': 'purple' }} />
      </>

      <div style={{ display: 'block', width: 700, padding: 30 }}>
        <h4>React-Bootstrap ProgressBar Component</h4>
        Current Progress is: {parseInt(countOfProgess)} %
        <ProgressBar now={countOfProgess} style={{ height: 30 }} />
      </div>
    </div>
  )
}

export default BootstrapTest
